export default {
  countMessages: 5,
  feedbacks: [
    {
      message: 'Welcome in Opus world',
      uid: 1,
    },
  ],
}
